// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/CRIBVEST Landscape Logo - Purple.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/propertiesBanner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Properties_parent__L4U1X {
    padding-top: 105px;
}

.Properties_innerMain__yZW8M {
    max-width: 1240px !important;
}

.Properties_navBarCon__n8U0W {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    padding: 35px 100px;
}

.Properties_navBar__-pSsE {
    max-width: 1240px;
}

.Properties_firstSection__jI\\+Ym {
    gap: 45px;
}

.Properties_logoContainer__EruVU {
    width: 150px;
    height: 20px;
    flex-shrink: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

.Properties_navItems__vLaVE {
    gap: 43px;
}

.Properties_navItem__oKpUB {
    padding: 8px 10px;
    color: #646464;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 114.286% */
    position: relative;
}

.Properties_navItem__oKpUB:after {
    content: '';
    width: 100%;
    height: 4px;
    transform: scale(0, 1);
    margin: 0 auto;
    position: absolute;
    top: calc(95% + 4px);
    /* bottom: 0; */
    /* flex-shrink: 0; */
    border: none;
    border-radius: 4px;
    overflow: hidden;
    background: #f2be15;
    transition: all 0.5s;
}

.Properties_navItem__oKpUB:hover:after {
    transform: scale(1, 1);
}

.Properties_focused__JwMuV {
    color: #000;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 114.286% */
}

.Properties_navItem__oKpUB.Properties_focused__JwMuV:after {
    transform: scale(1, 1) !important;
}

.Properties_propertiesBannerCon__ch\\+JL {
    padding: 115px 100px 0;
}

.Properties_pPropertiesBannerCon__4NHbw {
    background: linear-gradient(rgb(38 25 51 / 50%), rgb(25 25 51 / 50%)), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 450px;
    z-index: -1;
    top: 0;
    left: 0;
}

.Properties_propertyTheme__8HG5C {
    width: 418px;
    color: #fff;
    font-family: Manrope;
    font-size: 80px;
    font-style: normal;
    font-weight: 800;
    line-height: 90%; /* 72px */
    text-transform: capitalize;
}

.Properties_propertiesFilterCon__rymi6 {
    margin-top: 108px;
    border-radius: 20px;
    border: 1px solid #e3e4e9;
    background: #fff;
    /* height: 158px; */
    padding: 38px 36px;
    filter: drop-shadow(0px 18px 30px rgba(131, 119, 198, 0.11));
}

.Properties_filterCon__tq8v0 {
    width: calc(32%);
}

.Properties_searchCon__KjNKC {
    padding: 0 2px;
}

.Properties_searchCon___9GnqS {
    display: none !important;
}

.Properties_innerPropertiesFilterCon__wA5Uy {
    gap: 19px;
}

.Properties_searchButton__u\\+9VA {
    padding: 0 11px 0 23px !important;
    height: 56px !important;
    align-items: center;
    gap: 21px !important;
    flex-shrink: 0;
    background: #052E26 !important;
    color: #fff !important;
    justify-content: center !important;
}

.Properties_searchButton__u\\+9VA svg g path {
    color: #fff !important;
    /* fill: #fff; */
    stroke: #fff !important;
}

.Properties_searchTxt__b-mGk {
    color: #fff !important;
    font-family: Manrope !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 16px !important; /* 114.286% */
}

.Properties_gap__6KsU\\+ {
    display: none !important;
}

.Properties_propertiesListingCon__2yVSU {
    padding: 57px 100px;
}

.Properties_pProperty__im809 {
    margin-top: 10px;
    width: 31% !important;
    margin-bottom: 40px;
    border-radius: 20px;
    border: 1px solid #e3e4e9;
    overflow: hidden;
    padding-bottom: 15px;
    background: #fff;
}

.Properties_pProperty__im809:hover {
    box-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11);
}

.Properties_propertyLocCon__6jNm5 {
    gap: 6px;
}

.Properties_propertyPin__WHDlH {
    width: 16px;
    height: 16px;
}

.Properties_propertyLocation__bFkj5 {
    color: #828993;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
}

.Properties_propertyListing__tQ8aY {
    margin-top: 15px !important;
}

.Properties_propertyDetails__hbAuU {
    margin-top: 13px;
}

.Properties_propDetailIcon__9kTkH {
    width: 16px;
    height: 16.1px;
    flex-shrink: 0;
}

.Properties_propDetailText__NlYwg {
    color: #828993;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 150% */
}

.Properties_loadMoreCon__Byl9p {
    margin: 0 0 74px;
}

.Properties_loadMore__0XK9h {
    display: inline-flex;
    height: 45px;
    padding: 0px 18px;
    justify-content: center;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #e3e4e9;
    background: #fff;
}

.Properties_loadMoreTxt__MUWG2 {
    color: #7a7a7a;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 114.286% */
}

.Properties_loadMoreIcon__cj\\+c8 {
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
}

.Properties_loadMore__0XK9h.Properties_loading__KI1-4 .Properties_loadMoreIcon__cj\\+c8 {
    animation-name: Properties_loading__KI1-4;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

.Properties_propertyBannerCon__Q7QNr {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 465px;
    overflow: visible;
    /* z-index: -1;
    top: 0;
    left: 0; */
    padding: 33px 100px 55px;
}

.Properties_container__U39fz {
    padding-left: 100px;
    padding-right: 100px;
}

.Properties_propertyBanner__qxfUV {
}

.Properties_pPGoBackBtn__4CjLm {
    display: inline-flex;
    height: 45px;
    padding: 10.5px 18px;
    justify-content: center;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;
    border: none;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.4);
}

.Properties_pPGoBackIcon__QSiF0 {
    width: 24px;
    height: 24px;
}

.Properties_pPGoBackTxt__1LRL\\+ {
    color: #fff;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
}

.Properties_pPLocationInfoCon__cryj8 {
    gap: 23px;
}

.Properties_pPLocationInfoCon___OSi-3 {
    gap: initial;
    width: min(834px, 100%);
    padding: 54px 94px 87px;
}

.Properties_modalParent__RnzTY {
    width: min(834px, 100%);
}

.Properties_pPLocationCon__xztXd {
    gap: 6px;
}

.Properties_pPLocationIcon__xAHTW {
    width: 24px;
    height: 24px;
}

.Properties_pPLocation__D\\+iGC {
    color: #fff;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 100% */
    text-transform: capitalize;
}

.Properties_pViewPicturesBtn__5Lj3P {
    display: flex;
    height: 56px;
    padding: 0px 11px 0px 23px;
    justify-content: center;
    align-items: center;
    gap: 21px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #000;
    border: none;
}

.Properties_pViewPicturesBtn__5Lj3P.Properties_pViewPicturesBtnMini__oiIDc {
    height: 45px;
}

.Properties_pViewPicturesTxt__YHUDo {
    color: #fff;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 114.286% */
}

.Properties_pViewPicturesIcon__9xo8T {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.Properties_pMDetailsCon__EV8S5 {
    padding-top: 41px;
    padding-bottom: 60px;
}

.Properties_pMPropertyInfoCon__wAXmX {
    width: calc(100% - (425px + 92px));
}

.Properties_pMPropertyFeaturesCon__6j3hH {
    padding-bottom: 40px;
    border-bottom: 1px solid #e3e4e9;
}

.Properties_pMPropertyFeatIcon__5Uv08 {
    width: 25px;
    height: 25px;
    flex-shrink: 0;
}

.Properties_pPMPropertyFeatTxt__i75go {
    color: #828993;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 100% */
    text-transform: capitalize;
}

.Properties_pMPropertyInformationCon__QvaUw {
    margin-top: 41px;
}

.Properties_pMPropInfoTitle__Xfob1 {
    color: #13141c;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 21.6px */
}

.Properties_pMPropInfoContent__35kvN {
    color: #606060;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
}

.Properties_pMPropertyMetricsParent__y0IQ6 {
    width: 425px;
}

.Properties_pMPropertyMetricsCon__6ld54 {
    width: 100%;
    border: 1px solid #e3e4e9;
    border-radius: 15px;
    background: #fff;
    overflow: hidden;
    padding: 30px 33px;
}

.Properties_pPropMetricConBottom__RHWHD {
    margin-bottom: 28px;
}

.Properties_propMetricTag__JJbDF {
    color: #828993;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 214.286% */
}

.Properties_propMetricVal__lYgix {
    color: #13141c;
    text-align: right;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
}

.Properties_iViewDetailsBtn__-1JG8 {
    color: #fff !important;
    padding: 27px 32px;
    flex-shrink: 0;
    border-radius: 15px;
    background: #052E26;
    border: none;
    margin-top: 41px;
}

.Properties_iViewDetailsBtn__-1JG8:disabled {
    background: #e3e4e9 !important;
    cursor: not-allowed !important;
}

.Properties_iViewDetailsBtn__-1JG8 span {
    color: #fff;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 88.889% */
}

.Properties_iViewDetailsBtn__-1JG8 .Properties_sPlus__k4zyi path {
    color: #fff !important;
    stroke: #fff !important;
}

.Properties_firstPropMetric__ufBRE {
    width: 170px;
}

.Properties_propertyListing___8xv80 {
    margin-top: 0 !important;
}

.Properties_secondMetricCon__iIvnR {
    margin-top: 21px;
    padding: 30px 33px;
}

.Properties_propDocTitle__VnzsP {
    color: #13141c;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 21.6px */
    padding-bottom: 18px;
    border-bottom: 1px solid #e3e4e9;
}

.Properties_propDownloadBtn__2QHRM {
    padding: 21px 19px 21px 33px;
    border-radius: 25px;
    border: 1px solid #e3e4e9;
    background: #fff;
    margin-top: 19px;
}

.Properties_propDTxt__K4ycJ {
    color: #4e4e4e;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 114.286% */
}

.Properties_dIcon__QADLZ {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.Properties_showMore__MRgGV {
    color: #000;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    background: #fff;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 2px 5px 0;
}

.Properties_showLess__CRLxD {
    height: 84px;
    overflow: hidden;
    /* text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important; */
}

.Properties_pMInvestNowCon___2wr0M {
    padding-bottom: 53px;
    bottom: 0;
    background: #fff;
    right: 0;
}

.Properties_pMInvestNowCon___2wr0M .Properties_iViewDetailsBtn__-1JG8 {
    box-shadow: 0px 18px 20px 0px rgba(131, 119, 198, 0.25);
    margin-top: 0 !important;
}

.Properties_propertyBanner___6WPFm {
    width: min(calc(100% - 522px), 58%);
}

.Properties_investMetricsParent__NPpjE {
    width: 100%;
    flex-shrink: 0;
    border-radius: 15px;
    border: 1px solid #e3e4e9;
    background: #fff;
    padding: 50px 58px;
    /* position: absolute;
    right: auto;
    left: auto; */
    /* top: calc(100% - 122px); */
    z-index: 100;
}

.Properties_investMetricsParent_____3Ti9A {
    margin-bottom: 78px;
}

.Properties_investMetricsDummy__yb70C {
    width: min(calc(497px), calc(50%));
    flex-shrink: 0;
}

.Properties_pR20px__pgtY6 {
    padding-right: 20px;
}

.Properties_investMetricsParent__NPpjE .Properties_propMetricVal__lYgix {
    line-height: 22px;
}

.Properties_investMetricsParent__NPpjE .Properties_propMetricTag__JJbDF {
    line-height: 19.5px;
}

.Properties_investPurBtn__iKcWt {
    color: #fff;
    font-family: Manrope;
    line-height: 16px;
    font-size: 18px;
    display: flex;
    height: 73px;
    padding: 0px 8px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border: none;
    border-radius: 15px;
    background: #052E26;
    font-style: normal;
    font-weight: 500;
    margin-top: 29px;
}

.Properties_investPriceInput__UScjJ {
    display: flex;
    height: 64px;
    padding: 19px 16px 16px 20px;
    gap: 10px;
}

.Properties_investPriceInputIcon__abP9p {
    width: 24px;
    height: 24px;
}

.Properties_priceInput__SKcpk {
    color: #666;
    text-align: center;
    font-family: Manrope;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border: none;
}

.Properties_pPropMetricCon___m6HMR {
    padding-bottom: 22px;
    border-bottom: 1px solid #e3e4e9;
}

.Properties_paddedBottom__EJFry {
    padding-bottom: 22px;
    margin-bottom: 28px;
    border-bottom: 1px solid #e3e4e9;
}

.Properties_lineH30__vabVS {
    line-height: 30px !important;
}

.Properties_pSharesInvest__IkX4Z {
    color: #494747;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
}

.Properties_popup__wUUYS {
    /* height: 315px; */
    flex-shrink: 0;
    border: none;
    border-radius: 15px;
    background: #fff;
    padding: 125px 60px 47px;
    background: #0a0 !important;
}

.Properties_viewPortCon__ePPsB {
    margin-top: 86px;
}

.Properties_viewPortButton__alA0s {
    display: flex;
    width: 393px;
    height: 73px;
    padding: 0px 8px;
    flex-shrink: 0;
    border: none;
    border-radius: 15px;
    background: #fff;
    color: #494747;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 88.889% */
}

.Properties_popupSuccessTitle__mCBMv {
    color: #fff;
    text-align: center;
    font-family: Manrope;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 30px */
    margin-top: 33px;
}

.Properties_popupSuccessMessage__GwIgm {
    margin-top: 12px;
    color: #fff;
    text-align: center;
    font-family: Manrope;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 138.462% */
}

.Properties_youAreInvestingIn__xjnxN {
    color: #fff;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 100% */
    margin-bottom: 24px;
}

.Properties_pP22px__5oDpI {
    padding-bottom: 22px;
}

@keyframes Properties_loading__KI1-4 {
    0% {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.Properties_imgViewParent__znVkD {
    min-height: 100%;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 100000;
    background: rgba(0, 0, 0, 0.6);
    padding: 50px 40px;
    overflow-y: auto;
}

.Properties_imgViewBigCarousalCon__MCKRs {
    margin-bottom: 50px;
    flex: 1 1;
}

.Properties_imgViewBigCarousal__f8hhB {
    overflow-x: hidden;
    height: 400px;
}

.Properties_progressButton__1HAOK {
    padding: 20px;
    border: none;
    border-radius: 50%;
    background: #052E26;
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0;
}

.Properties_progressButtonRight__K5FJH {
    right: 0;
    left: initial;
}

.Properties_progressButtonIcon__P5P8x {
    width: 24px;
    height: 24px;
}

.Properties_progressButtonIconRight__U\\+xcm {
    transform: rotate(180deg);
}

.Properties_imgViewBigOnes__\\+s27p {
    height: 400px;
    transition: 0.3s;
}

.Properties_imgViewPropertySample__VryDY {
    border: none;
    border-radius: 10px;
    width: auto;
    aspect-ratio: auto;
}

.Properties_imgViewSmallOnesCon__gtCb1 {
    height: 150px;
    overflow-x: auto;
    padding-bottom: 15px;
}

.Properties_imgViewSmallOnesCon__gtCb1::-webkit-scrollbar {
    /* opacity: 0; */
    height: 8px !important;
}

.Properties_imgViewSmallOnes__FdNcV {
    gap: 10px;
}

.Properties_imgViewMiniPropertySample__BHxzY {
    border: 3px solid transparent;
    border-radius: 5px;
    overflow: hidden;
    width: auto;
    aspect-ratio: auto;
}

.Properties_imgViewMiniPropertySample__BHxzY.Properties_imgInView__WKRxE {
    border-color: #052E26;
}

.Properties_imgViewClose__QmYQ- {
    top: 40px;
    right: 40px;
    width: 50px;
    height: 50px;
    bottom: initial;
    padding: 0 !important;
    left: initial;
    background: #000;
    color: #fff;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
}

.Properties_xCheckout__Jh5pt {
    border-radius: 15px;
    border: 1px solid #e3e4e9;
    background: #f6f6f6;
    padding: 28px 58px 14.5px;
    margin-top: 14px;
}

.Properties_xCheckoutTitle__wnYo0 {
    color: #000;
    text-align: center;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 100% */
}

.Properties_xCheckoutLabel__SVH24 {
    margin-top: 18px;
    gap: 8px;
}

.Properties_xCheckoutLabelSpan__07uxr {
    color: #494747;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
}

.Properties_xCheckoutHiddenDiv__TB-BC {
    border-radius: 5px;
    border: 1px solid #ccc;
    background: var(--W-Background, #fff);
    padding: 16px 20px;
    gap: 30px;
}

.Properties_xCheckoutHiddenR__Oan9e {
    color: #13141c;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
    width: 32px;
}

.Properties_xCheckoutInput__Cgw9C {
    color: #666;
    font-family: Manrope;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border: none;
    outline: none;
    width: calc(100% - 62px);
}

.Properties_xInfoCon__TW7Oo {
    border-top: 1px solid #d4d4d4;
    padding: 24px 0 31px;
    margin-top: 30px;
}

.Properties_xInfo__qYkHR {
    width: 33%;
}

.Properties_xInfoTitle__W1zev {
    color: var(--Grey-30, #999);
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.2px; /* 137.143% */
}

.Properties_xInfoSubtitle__T0Pt6 {
    color: #13141c;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */
}

.Properties_xCost__JWHrI {
    padding: 23px 0;
    border-top: 1px solid #d4d4d4;
}

.Properties_xCostTag__ZUluH {
    color: #696969;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
}

.Properties_xCostValue__\\+\\+4hf {
    color: #595959;
    text-align: right;
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%; /* 17.6px */
}

.Properties_xCheckoutNotice__femWo {
    gap: 15px;
    padding: 20px 0 78px;
}

.Properties_xCheckoutNoticeText__vxA9y {
    color: #5f5f5f;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 16.8px */
}

.Properties_xCheckoutNoticeTextLink__\\+kqC2 {
    color: #5f5f5f;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
}

.Properties_purchaseButton__BsdHL {
    color: #fff;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 88.889% */
    padding: 0 20px;
    min-width: 280px;
    height: 73px;
    padding: 0px 8px;
    justify-content: center;
    align-items: center;
    gap: 125px;
    flex-shrink: 0;
    border-radius: 15px;
    background: #052E26;
    margin: 0;
}

.Properties_xOffers__G2vFg {
    gap: 108px;
    padding-top: 41px;
}

.Properties_xOffer__X0RWe {
    gap: 17px;
}

.Properties_xOfferIcon__pK2Gf {
    width: 25px;
    height: 31.25px;
}

.Properties_xOfferDetails__Ppd5B {
}

.Properties_xOfferTitle__o0lJg {
    color: #828993;
    font-family: Manrope;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 163.636% */
}

.Properties_xOfferValue__-kVuc {
    color: #828993;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 100% */
}

.Properties_xxGrossYield__GnzuD {
    margin-top: 15px;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
}

.Properties_xxGrossYieldTag__d4Oda {
    color: #828993;
    font-family: Manrope;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 230.769% */
}

.Properties_xxGrossYieldValue__15KdQ {
    color: #13141c;
    text-align: right;
    font-family: Manrope;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 230.769% */
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
    .Properties_navItems__vLaVE {
        gap: 0 !important;
    }

    .Properties_pMDetailsCon__EV8S5 {
        padding-top: 5px;
    }

    .Properties_propertyDetail__1LoDo {
        margin-top: 19px;
    }

    .Properties_pMPropertyFeaturesCon__6j3hH {
        padding-bottom: 15px;
    }

    .Properties_pMPropertyFeatIcon__5Uv08 {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .Properties_pPMPropertyFeatTxt__i75go {
        color: #828993;
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 150% */
    }

    .Properties_pMPropertyInfoCon__wAXmX {
        width: 100%;
    }

    .Properties_pMPropertyMetricsParent__y0IQ6 {
        width: 100%;
        gap: 20px;
        margin-top: 31px;
    }

    .Properties_pMPropertyMetricsCon__6ld54 {
        width: 100% !important;
    }

    .Properties_secondMetricCon__iIvnR {
        width: 100% !important;
        margin-top: 0;
        padding: 24px 24px 30px;
    }

    .Properties_propDownloadBtn__2QHRM {
        padding: 15px 13px 15px 15px;
    }
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
}

@media only screen and (max-width: 850px) and (min-width: 821px) {
    .Properties_pMPropertyInfoCon__wAXmX {
        width: 100% !important;
    }

    .Properties_pMPropertyMetricsParent__y0IQ6 {
        width: 100% !important;
        gap: 20px !important;
        margin-top: 31px !important;
    }

    .Properties_pMPropertyMetricsCon__6ld54:not(.Properties_secondMetricCon__iIvnR) {
        width: calc(60% - 20px);
    }

    .Properties_secondMetricCon__iIvnR {
        width: 40%;
        margin-top: 0 !important;
        padding: 24px 24px 30px !important;
    }

    .Properties_propDownloadBtn__2QHRM {
        padding: 15px 13px 15px 15px !important;
    }

    /* .investMetricsParent {
        width: min(497px, calc(60% - 42px));
    } */
    .Properties_investMetricsDummy__yb70C {
        width: min(497px, calc(60%));
    }

    /* .iPadHidden{
        display: none !important;
    }

    .propThemeTitle {
        margin: 60px 0 65px !important;
    }

    .investMetricsParent {
        position: static;
        width: 100%;
    } */
}

@media only screen and (max-width: 820px) {
    .Properties_navBarCon__n8U0W {
        padding: 30px 42px;
    }

    .Properties_propertiesBannerCon__ch\\+JL {
        padding: 195px 42px 0;
        /* background-size: 1440px 450px; */
    }

    .Properties_propertyTheme__8HG5C {
        color: #fff;
        font-family: Manrope;
        font-size: 50px;
        font-style: normal;
        font-weight: 800;
        line-height: 100%; /* 50px */
    }

    .Properties_propertiesFilterCon__rymi6 {
        margin-top: 71px;
    }

    .Properties_filterCon__tq8v0 {
        width: calc(48%);
    }

    .Properties_searchCon___9GnqS {
        display: flex !important;
        width: calc(48%) !important;
    }

    .Properties_searchCon__KjNKC {
        display: none !important;
        padding: 0 !important;
    }

    .Properties_searchButton__u\\+9VA {
        display: flex;
        width: 100% !important;
        height: 56px !important;
        padding: 0px 11px 0px 23px !important;
        align-items: center;
        gap: 21px !important;
        flex-shrink: 0;
        background: #052E26 !important;
        color: #fff !important;
        justify-content: center !important;
    }

    .Properties_searchButton__u\\+9VA svg g path {
        color: #fff !important;
        /* fill: #fff; */
        stroke: #fff !important;
    }

    .Properties_gap__6KsU\\+ {
        display: flex !important;
        height: 20px;
    }

    .Properties_propertiesListingCon__2yVSU {
        padding: 43px 42px;
    }

    .Properties_pProperty__im809 {
        width: 48% !important;
        margin-bottom: 35px;
    }

    .Properties_pPropertyImage__3G3GP {
        padding: 30px !important;
    }

    .Properties_pMPropertyMetricsCon__6ld54:not(.Properties_noPadding__9ETfl) {
        padding: 15px 30px !important;
    }

    .Properties_pPropertyName__Cbpwx {
        font-size: 18px !important;
        font-style: normal !important;
        font-weight: 600 !important;
        line-height: 30px !important; /* 166.667% */
    }

    .Properties_propertyLocation__bFkj5 {
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: 18px !important; /* 150% */
    }

    .Properties_pPropLeft__Sf2po {
        font-size: 13px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: 30px !important; /* 230.769% */
    }

    .Properties_pPropRight__LbnTO {
        font-size: 13px !important;
        font-style: normal !important;
        font-weight: 600 !important;
        line-height: 30px !important; /* 230.769% */
    }

    .Properties_pPropertyShares__JpU-J {
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 700 !important;
        line-height: 30px !important; /* 250% */
        padding: 3px 15px !important;
        border-radius: 10px !important;
    }

    .Properties_propertyBannerCon__Q7QNr {
        padding: 33px 42px 62px !important;
    }

    .Properties_container__U39fz {
        padding-left: 42px;
        padding-right: 42px;
    }

    .Properties_pViewPicturesIcon__9xo8T {
        width: 20px;
        height: 20px;
    }

    .Properties_pMPropertyInfoCon__wAXmX {
        width: 100%;
    }

    .Properties_pMPropertyMetricsParent__y0IQ6 {
        width: 100%;
        gap: 20px;
        margin-top: 31px;
    }

    .Properties_pMPropertyMetricsCon__6ld54:not(.Properties_secondMetricCon__iIvnR) {
        width: calc(60% - 20px);
    }

    .Properties_secondMetricCon__iIvnR {
        width: 40%;
        margin-top: 0;
        padding: 24px 24px 30px;
    }

    .Properties_propDownloadBtn__2QHRM {
        padding: 15px 13px 15px 15px;
    }

    .Properties_propDTxt__K4ycJ {
    }

    .Properties_dIcon__QADLZ {
    }

    /*.investMetricsParent {
        width: min(497px, calc(60% - 42px));
        right: 42px;
    } */
    .Properties_investMetricsDummy__yb70C {
        width: min(497px, calc(60%));
    }

    .Properties_propThemeTitle__jKw9x {
        margin: 60px 0 65px !important;
    }

    /* .investMetricsParent {
        position: static;
        width: 100%;
    } */
    .Properties_imgViewParent__znVkD {
        padding: 40px 20px !important;
    }

    /*
    .imgViewPropertySampleCon {
        height: initial !important;
    }

    .imgViewPropertySample {
        height: auto !important;
        width: 100% !important;
    } */
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
    .Properties_parent__L4U1X {
        padding-top: 85px;
    }

    .Properties_navBarCon__n8U0W {
        padding: 20px 30px;
    }

    .Properties_propertiesBannerCon__ch\\+JL {
        padding: 141px 30px 0;
    }

    .Properties_propertiesFilterCon__rymi6 {
        padding: 38px 31px;
        margin-top: 126px;
    }

    .Properties_propertiesFilterInnerCon__r-Tlp {
        flex-direction: column !important;
        justify-content: center !important;
        align-items: center !important;
        gap: 24px !important;
    }

    .Properties_filterCon__tq8v0 {
        width: calc(100%);
    }

    .Properties_searchCon___9GnqS {
        width: calc(100%) !important;
    }

    .Properties_gap__6KsU\\+ {
        display: none !important;
    }

    .Properties_firstPropMetric__ufBRE {
        width: initial !important;
        margin-right: auto !important;
    }

    .Properties_firstPropMetric__ufBRE + div {
        width: initial !important;
        flex: none !important;
        margin-left: auto !important;
    }

    .Properties_propertiesListingCon__2yVSU {
        padding: 41px 29px;
    }

    .Properties_pProperty__im809 {
        width: 100% !important;
        margin-bottom: 27px;
    }

    .Properties_pPropertyImage__3G3GP {
        height: 254px !important;
        padding: 30px !important;
    }

    .Properties_pPropLeft__Sf2po {
        font-size: 13px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: 30px !important; /* 230.769% */
    }

    .Properties_pPropRight__LbnTO {
        font-size: 13px !important;
        font-style: normal !important;
        font-weight: 600 !important;
        line-height: 30px !important; /* 230.769% */
    }

    .Properties_pPropertyShares__JpU-J {
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 700 !important;
        line-height: 30px !important; /* 250% */
        padding: 3px 15px !important;
        border-radius: 10px !important;
    }

    .Properties_propertyBannerCon__Q7QNr {
        padding: 20px 30px 28px !important;
    }

    .Properties_container__U39fz {
        padding-left: 30px;
        padding-right: 30px;
    }

    .Properties_pPLocationInfoCon__cryj8 {
        padding: 0 16px;
    }

    .Properties_pPLocationInfoCon___OSi-3 {
        padding: 0;
    }

    .Properties_pPLocation__D\\+iGC {
        color: #fff;
        font-family: Manrope;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }

    .Properties_pMDetailsCon__EV8S5 {
        padding-top: 5px;
    }

    .Properties_propertyDetail__1LoDo {
        margin-top: 19px;
    }

    .Properties_pMPropertyFeaturesCon__6j3hH {
        padding-bottom: 15px;
    }

    .Properties_pMDetailsCon__EV8S5 {
        padding-bottom: 169.5px;
    }

    .Properties_pMPropertyFeatIcon__5Uv08 {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .Properties_pPMPropertyFeatTxt__i75go {
        color: #828993;
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 150% */
    }

    .Properties_pMPropertyInfoCon__wAXmX {
        width: 100%;
    }

    .Properties_pMPropertyMetricsParent__y0IQ6 {
        width: 100%;
        gap: 20px;
        margin-top: 31px;
    }

    .Properties_propDocTitle__VnzsP {
        color: #13141c;
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%; /* 14.4px */
    }

    .Properties_pMPropertyMetricsCon__6ld54 {
        width: 100% !important;
        border: none;
        border-radius: 0px !important;
        padding: 0;
    }

    .Properties_propertyListing___8xv80 {
        border-top: 1px solid #e3e4e9 !important;
        padding-top: 19px !important;
    }

    .Properties_m19__1duoH {
        margin-bottom: 19px !important;
    }

    .Properties_pPropertyDetails__Kdn09 {
        /* padding: 10px 0 !important; */
    }

    .Properties_secondMetricCon__iIvnR {
        width: 100% !important;
        margin-top: 32px !important;
        border: none !important;
        padding: 10px 0 !important;
    }

    .Properties_propDownloadBtn__2QHRM {
        padding: 15px 13px 15px 15px;
    }

    .Properties_searchButton__u\\+9VA {
        background: #052E26 !important;
        color: #fff !important;
    }

    .Properties_searchButton__u\\+9VA path {
        color: #fff !important;
        /* fill: #fff; */
        stroke: #fff !important;
    }

    .Properties_propertyBanner___6WPFm {
        width: 100%;
        height: initial !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    .Properties_youAreInvestingIn__xjnxN {
        color: #fff;
        font-family: Manrope;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        margin-bottom: 14px;
    }

    .Properties_propThemeTitle__jKw9x {
        margin: 46px 0 45px !important;
    }

    .Properties_propertyTheme__8HG5C {
        color: #fff;
        font-family: Manrope;
        font-size: 50px;
        font-style: normal;
        font-weight: 800;
        line-height: 90%; /* 45px */
        text-transform: capitalize;
    }

    .Properties_investMetricsParent__NPpjE {
        position: static;
        width: 100%;
    }

    .Properties_investMetricsParent___QkeEI {
        padding: 34px 30px 41px;
    }

    .Properties_popup__wUUYS {
        padding: 115px 26px 27px;
        margin-bottom: 50px;
    }

    .Properties_popupCheckCon__X3ZLd {
        width: 70px;
        height: 70px;
    }

    .Properties_popupCheck__-B\\+uL {
        width: 31px;
        height: 31px;
    }

    .Properties_popupSuccessTitle__mCBMv {
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%; /* 21.6px */
    }

    .Properties_popupSuccessMessage__GwIgm {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
    }

    .Properties_progressButton__1HAOK {
        position: relative !important;
        width: calc(50% - 5px) !important;
        border-radius: 10px !important;
        margin: 0 auto;
    }

    .Properties_imgViewParent__znVkD {
        padding: 20px 10px 100px !important;
    }

    .Properties_imgViewBigOnes__\\+s27p {
        height: 250px;
    }

    .Properties_imgViewPropertySampleCon__Nhf7P {
        height: initial !important;
    }

    .Properties_imgViewPropertySample__VryDY {
        height: auto !important;
        width: 100% !important;
    }

    .Properties_imgViewSmallOnesCon__gtCb1 {
        height: 100px !important;
    }

    .Properties_imgViewClose__QmYQ- {
        width: 100% !important;
        padding: 20px 0 !important;
        height: initial !important;
        top: initial !important;
        right: initial !important;
        bottom: initial !important;
        left: initial !important;
        margin-top: 50px !important;
    }

    .Properties_xCheckout__Jh5pt {
        padding: 21px 27px 18px;
        margin-top: 20px;
    }

    .Properties_xCheckoutTitle__wnYo0 {
        color: #000;
        text-align: center;
        font-family: Manrope;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 112.5% */
    }

    .Properties_xCheckoutLabel__SVH24 {
        margin-top: 32px;
    }

    .Properties_xCheckoutHiddenDiv__TB-BC {
        gap: 20px;
    }

    .Properties_xCheckoutHiddenR__Oan9e {
        width: 20px;
    }

    .Properties_xCheckoutInput__Cgw9C {
        width: calc(100% - 40px);
    }

    .Properties_xInfoCon__TW7Oo {
        padding: 22px 0 13px;
    }

    .Properties_xInfo__qYkHR {
        flex-direction: row !important;
        width: initial;
    }

    .Properties_xInfo__qYkHR:not(.Properties_xInfo__qYkHR.Properties_xInfoWithBorder__21T9O) {
        flex: 1 1;
    }

    .Properties_xInfo__qYkHR.Properties_xInfoWithBorder__21T9O {
        padding-top: 10px;
        margin-top: 16px;
        border-top: 1px solid #d4d4d4;
    }

    .Properties_xInfoTitle__W1zev {
        font-size: 12px;
    }

    .Properties_xInfoSubtitle__T0Pt6 {
        font-size: 15px;
    }

    .Properties_xCostTag__ZUluH {
        font-size: 12px;
    }

    .Properties_xCostValue__\\+\\+4hf {
        font-size: 14px;
    }

    .Properties_xCheckoutAgreement__o4LdV {
        width: 100%;
    }

    .Properties_purchaseButton__BsdHL {
        font-size: 14px;
        width: 100%;
        margin-top: 27px;
    }

    .Properties_xOffers__G2vFg {
        gap: initial !important;
        padding-top: 15px !important;
    }

    .Properties_xOffer__X0RWe {
        width: 100%;
    }

    .Properties_xOffer__X0RWe:not(.Properties_xOffer__X0RWe:last-of-type) {
        margin-bottom: 26px;
    }

    .Properties_xOfferIcon__pK2Gf {
        width: 20px;
        height: 25.217px;
    }

    .Properties_xOfferTitle__o0lJg {
        font-size: 9px;
    }

    .Properties_xOfferValue__-kVuc {
        font-size: 14px;
    }
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Properties.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mDAAwE;IACxE,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8GAAmH;IACnH,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB,EAAE,SAAS;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;IAEvB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,8BAA8B;IAC9B,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B,EAAE,aAAa;AAC/C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yCAAuB;IACvB,sBAAsB;IACtB,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,iBAAiB;IACjB;;cAEU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;AACA;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;AAClC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,YAAY;AACnC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;IAC9B,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB;;qCAEiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,uDAAuD;IACvD,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB;;iBAEa;IACb,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,YAAY;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;IACrC,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAE,aAAa;AACtC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;AAClC;;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;AAClC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,YAAY;IAC/B,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;AACA;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA,yDAAyD;AACzD;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,SAAS;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;AACA;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,wBAAwB;QACxB,kCAAkC;IACtC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;;OAEG;IACH;QACI,4BAA4B;IAChC;;IAEA;;;;;;;;;;;OAWG;AACP;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,mCAAmC;IACvC;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,SAAS;IAChC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;QAIxB,2BAA2B;IAH/B;;IAMA;QACI,wBAAwB;QACxB,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,qCAAqC;QAErC,mBAAmB;QACnB,oBAAoB;QACpB,cAAc;QACd,8BAA8B;QAC9B,sBAAsB;QACtB,kCAAkC;IACtC;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;QACxB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,aAAa;IAC/C;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,SAAS;IAC3C;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,aAAa;IAC/C;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,aAAa;IAC/C;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,SAAS;QACvC,4BAA4B;QAC5B,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;IACA;;IAEA;IACA;;IAEA;;;OAGG;IACH;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;;OAGG;IACH;QACI,6BAA6B;IACjC;;IAEA;;;;;;;;OAQG;AACP;;AAEA;AACA;;AAEA;AACA;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,iCAAiC;QACjC,kCAAkC;QAClC,8BAA8B;QAC9B,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,aAAa;IAC/C;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,aAAa;IAC/C;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B,EAAE,SAAS;QACvC,4BAA4B;QAC5B,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,aAAa;IACpC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,SAAS;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,WAAW;IAClC;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,6BAA6B;QAC7B,UAAU;IACd;;IAEA;QACI,wCAAwC;QACxC,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,0BAA0B;QAC1B,sCAAsC;QACtC,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,aAAa;QAChC,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB,EAAE,SAAS;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,WAAW;IAClC;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,SAAS;IAChC;;IAEA;QACI,6BAA6B;QAC7B,iCAAiC;QACjC,8BAA8B;QAC9B,cAAc;IAClB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,0BAA0B;QAC1B,uBAAuB;QACvB,yBAAyB;QACzB,0BAA0B;QAC1B,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,WAAW;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,8BAA8B;QAC9B,cAAc;IAClB;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".parent {\n    padding-top: 105px;\n}\n\n.innerMain {\n    max-width: 1240px !important;\n}\n\n.navBarCon {\n    background: #fff;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    padding: 35px 100px;\n}\n\n.navBar {\n    max-width: 1240px;\n}\n\n.firstSection {\n    gap: 45px;\n}\n\n.logoContainer {\n    width: 150px;\n    height: 20px;\n    flex-shrink: 0;\n    background: url('../assets/images/CRIBVEST Landscape Logo - Purple.png');\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n\n.navItems {\n    gap: 43px;\n}\n\n.navItem {\n    padding: 8px 10px;\n    color: #646464;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px; /* 114.286% */\n    position: relative;\n}\n\n.navItem:after {\n    content: '';\n    width: 100%;\n    height: 4px;\n    transform: scale(0, 1);\n    margin: 0 auto;\n    position: absolute;\n    top: calc(95% + 4px);\n    /* bottom: 0; */\n    /* flex-shrink: 0; */\n    border: none;\n    border-radius: 4px;\n    overflow: hidden;\n    background: #f2be15;\n    transition: all 0.5s;\n}\n\n.navItem:hover:after {\n    transform: scale(1, 1);\n}\n\n.focused {\n    color: #000;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px; /* 114.286% */\n}\n\n.navItem.focused:after {\n    transform: scale(1, 1) !important;\n}\n\n.propertiesBannerCon {\n    padding: 115px 100px 0;\n}\n\n.pPropertiesBannerCon {\n    background: linear-gradient(rgb(38 25 51 / 50%), rgb(25 25 51 / 50%)), url('../assets/images/propertiesBanner.jpg');\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    height: 450px;\n    z-index: -1;\n    top: 0;\n    left: 0;\n}\n\n.propertyTheme {\n    width: 418px;\n    color: #fff;\n    font-family: Manrope;\n    font-size: 80px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 90%; /* 72px */\n    text-transform: capitalize;\n}\n\n.propertiesFilterCon {\n    margin-top: 108px;\n    border-radius: 20px;\n    border: 1px solid #e3e4e9;\n    background: #fff;\n    /* height: 158px; */\n    padding: 38px 36px;\n    filter: drop-shadow(0px 18px 30px rgba(131, 119, 198, 0.11));\n}\n\n.filterCon {\n    width: calc(32%);\n}\n\n.searchCon {\n    padding: 0 2px;\n}\n\n.searchCon_ {\n    display: none !important;\n}\n\n.innerPropertiesFilterCon {\n    gap: 19px;\n}\n\n.searchButton {\n    padding: 0 11px 0 23px !important;\n    height: 56px !important;\n    justify-content: center;\n    align-items: center;\n    gap: 21px !important;\n    flex-shrink: 0;\n    background: #052E26 !important;\n    color: #fff !important;\n    justify-content: center !important;\n}\n\n.searchButton svg g path {\n    color: #fff !important;\n    /* fill: #fff; */\n    stroke: #fff !important;\n}\n\n.searchTxt {\n    color: #fff !important;\n    font-family: Manrope !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    line-height: 16px !important; /* 114.286% */\n}\n\n.gap {\n    display: none !important;\n}\n\n.propertiesListingCon {\n    padding: 57px 100px;\n}\n\n.pProperty {\n    margin-top: 10px;\n    width: 31% !important;\n    margin-bottom: 40px;\n    border-radius: 20px;\n    border: 1px solid #e3e4e9;\n    overflow: hidden;\n    padding-bottom: 15px;\n    background: #fff;\n}\n\n.pProperty:hover {\n    box-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11);\n}\n\n.propertyLocCon {\n    gap: 6px;\n}\n\n.propertyPin {\n    width: 16px;\n    height: 16px;\n}\n\n.propertyLocation {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n}\n\n.propertyListing {\n    margin-top: 15px !important;\n}\n\n.propertyDetails {\n    margin-top: 13px;\n}\n\n.propDetailIcon {\n    width: 16px;\n    height: 16.1px;\n    flex-shrink: 0;\n}\n\n.propDetailText {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 150% */\n}\n\n.loadMoreCon {\n    margin: 0 0 74px;\n}\n\n.loadMore {\n    display: inline-flex;\n    height: 45px;\n    padding: 0px 18px;\n    justify-content: center;\n    align-items: center;\n    gap: 7px;\n    flex-shrink: 0;\n    border-radius: 10px;\n    border: 1px solid #e3e4e9;\n    background: #fff;\n}\n\n.loadMoreTxt {\n    color: #7a7a7a;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 114.286% */\n}\n\n.loadMoreIcon {\n    width: 24px;\n    height: 24px;\n    border: none;\n    border-radius: 50%;\n}\n\n.loadMore.loading .loadMoreIcon {\n    animation-name: loading;\n    animation-duration: 1s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n\n.propertyBannerCon {\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    height: 465px;\n    overflow: visible;\n    /* z-index: -1;\n    top: 0;\n    left: 0; */\n    padding: 33px 100px 55px;\n}\n\n.container {\n    padding-left: 100px;\n    padding-right: 100px;\n}\n\n.propertyBanner {\n}\n\n.pPGoBackBtn {\n    display: inline-flex;\n    height: 45px;\n    padding: 10.5px 18px;\n    justify-content: center;\n    align-items: center;\n    gap: 7px;\n    flex-shrink: 0;\n    border: none;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.4);\n}\n\n.pPGoBackIcon {\n    width: 24px;\n    height: 24px;\n}\n\n.pPGoBackTxt {\n    color: #fff;\n    font-family: Manrope;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 133.333% */\n}\n\n.pPLocationInfoCon {\n    gap: 23px;\n}\n\n.pPLocationInfoCon_ {\n    gap: initial;\n    width: min(834px, 100%);\n    padding: 54px 94px 87px;\n}\n\n.modalParent {\n    width: min(834px, 100%);\n}\n\n.pPLocationCon {\n    gap: 6px;\n}\n\n.pPLocationIcon {\n    width: 24px;\n    height: 24px;\n}\n\n.pPLocation {\n    color: #fff;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 100% */\n    text-transform: capitalize;\n}\n\n.pViewPicturesBtn {\n    display: flex;\n    height: 56px;\n    padding: 0px 11px 0px 23px;\n    justify-content: center;\n    align-items: center;\n    gap: 21px;\n    flex-shrink: 0;\n    border-radius: 10px;\n    background: #000;\n    border: none;\n}\n\n.pViewPicturesBtn.pViewPicturesBtnMini {\n    height: 45px;\n}\n\n.pViewPicturesTxt {\n    color: #fff;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 114.286% */\n}\n\n.pViewPicturesIcon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n.pMDetailsCon {\n    padding-top: 41px;\n    padding-bottom: 60px;\n}\n\n.pMPropertyInfoCon {\n    width: calc(100% - (425px + 92px));\n}\n\n.pMPropertyFeaturesCon {\n    padding-bottom: 40px;\n    border-bottom: 1px solid #e3e4e9;\n}\n\n.pMPropertyFeatIcon {\n    width: 25px;\n    height: 25px;\n    flex-shrink: 0;\n}\n\n.pPMPropertyFeatTxt {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 100% */\n    text-transform: capitalize;\n}\n\n.pMPropertyInformationCon {\n    margin-top: 41px;\n}\n\n.pMPropInfoTitle {\n    color: #13141c;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 21.6px */\n}\n\n.pMPropInfoContent {\n    color: #606060;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%; /* 21px */\n}\n\n.pMPropertyMetricsParent {\n    width: 425px;\n}\n\n.pMPropertyMetricsCon {\n    width: 100%;\n    border: 1px solid #e3e4e9;\n    border-radius: 15px;\n    background: #fff;\n    overflow: hidden;\n    padding: 30px 33px;\n}\n\n.pPropMetricConBottom {\n    margin-bottom: 28px;\n}\n\n.propMetricTag {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 30px; /* 214.286% */\n}\n\n.propMetricVal {\n    color: #13141c;\n    text-align: right;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px; /* 166.667% */\n}\n\n.iViewDetailsBtn {\n    background: #052E26 !important;\n    color: #fff !important;\n    padding: 27px 32px;\n    flex-shrink: 0;\n    border-radius: 15px;\n    background: #052E26;\n    border: none;\n    margin-top: 41px;\n}\n\n.iViewDetailsBtn:disabled {\n    background: #e3e4e9 !important;\n    cursor: not-allowed !important;\n}\n\n.iViewDetailsBtn span {\n    color: #fff;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 88.889% */\n}\n\n.iViewDetailsBtn .sPlus path {\n    color: #fff !important;\n    stroke: #fff !important;\n}\n\n.firstPropMetric {\n    width: 170px;\n}\n\n.propertyListing_ {\n    margin-top: 0 !important;\n}\n\n.secondMetricCon {\n    margin-top: 21px;\n    padding: 30px 33px;\n}\n\n.propDocTitle {\n    color: #13141c;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 21.6px */\n    padding-bottom: 18px;\n    border-bottom: 1px solid #e3e4e9;\n}\n\n.propDownloadBtn {\n    padding: 21px 19px 21px 33px;\n    border-radius: 25px;\n    border: 1px solid #e3e4e9;\n    background: #fff;\n    margin-top: 19px;\n}\n\n.propDTxt {\n    color: #4e4e4e;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 114.286% */\n}\n\n.dIcon {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n}\n\n.showMore {\n    color: #000;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 150%;\n    background: #fff;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    padding: 2px 5px 0;\n}\n\n.showLess {\n    height: 84px;\n    overflow: hidden;\n    /* text-overflow: ellipsis !important;\n    overflow: hidden !important;\n    white-space: nowrap !important; */\n}\n\n.pMInvestNowCon_ {\n    padding-bottom: 53px;\n    bottom: 0;\n    background: #fff;\n    right: 0;\n}\n\n.pMInvestNowCon_ .iViewDetailsBtn {\n    box-shadow: 0px 18px 20px 0px rgba(131, 119, 198, 0.25);\n    margin-top: 0 !important;\n}\n\n.propertyBanner_ {\n    width: min(calc(100% - 522px), 58%);\n}\n\n.investMetricsParent {\n    width: 100%;\n    flex-shrink: 0;\n    border-radius: 15px;\n    border: 1px solid #e3e4e9;\n    background: #fff;\n    padding: 50px 58px;\n    /* position: absolute;\n    right: auto;\n    left: auto; */\n    /* top: calc(100% - 122px); */\n    z-index: 100;\n}\n\n.investMetricsParent___ {\n    margin-bottom: 78px;\n}\n\n.investMetricsDummy {\n    width: min(calc(497px), calc(50%));\n    flex-shrink: 0;\n}\n\n.pR20px {\n    padding-right: 20px;\n}\n\n.investMetricsParent .propMetricVal {\n    line-height: 22px;\n}\n\n.investMetricsParent .propMetricTag {\n    line-height: 19.5px;\n}\n\n.investPurBtn {\n    color: #fff;\n    font-family: Manrope;\n    line-height: 16px;\n    font-size: 18px;\n    display: flex;\n    height: 73px;\n    padding: 0px 8px;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border: none;\n    border-radius: 15px;\n    background: #052E26;\n    font-style: normal;\n    font-weight: 500;\n    margin-top: 29px;\n}\n\n.investPriceInput {\n    display: flex;\n    height: 64px;\n    padding: 19px 16px 16px 20px;\n    gap: 10px;\n}\n\n.investPriceInputIcon {\n    width: 24px;\n    height: 24px;\n}\n\n.priceInput {\n    color: #666;\n    text-align: center;\n    font-family: Manrope;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    border: none;\n}\n\n.pPropMetricCon_ {\n    padding-bottom: 22px;\n    border-bottom: 1px solid #e3e4e9;\n}\n\n.paddedBottom {\n    padding-bottom: 22px;\n    margin-bottom: 28px;\n    border-bottom: 1px solid #e3e4e9;\n}\n\n.lineH30 {\n    line-height: 30px !important;\n}\n\n.pSharesInvest {\n    color: #494747;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px; /* 128.571% */\n}\n\n.popup {\n    /* height: 315px; */\n    flex-shrink: 0;\n    border: none;\n    border-radius: 15px;\n    background: #fff;\n    padding: 125px 60px 47px;\n    background: #0a0 !important;\n}\n\n.viewPortCon {\n    margin-top: 86px;\n}\n\n.viewPortButton {\n    display: flex;\n    width: 393px;\n    height: 73px;\n    padding: 0px 8px;\n    flex-shrink: 0;\n    border: none;\n    border-radius: 15px;\n    background: #fff;\n    color: #494747;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 88.889% */\n}\n\n.popupSuccessTitle {\n    color: #fff;\n    text-align: center;\n    font-family: Manrope;\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 30px */\n    margin-top: 33px;\n}\n\n.popupSuccessMessage {\n    margin-top: 12px;\n    color: #fff;\n    text-align: center;\n    font-family: Manrope;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 138.462% */\n}\n\n.youAreInvestingIn {\n    color: #fff;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 100% */\n    margin-bottom: 24px;\n}\n\n.pP22px {\n    padding-bottom: 22px;\n}\n\n@keyframes loading {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    50% {\n        transform: rotate(180deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.imgViewParent {\n    min-height: 100%;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 100000;\n    background: rgba(0, 0, 0, 0.6);\n    padding: 50px 40px;\n    overflow-y: auto;\n}\n\n.imgViewBigCarousalCon {\n    margin-bottom: 50px;\n    flex: 1;\n}\n\n.imgViewBigCarousal {\n    overflow-x: hidden;\n    height: 400px;\n}\n\n.progressButton {\n    padding: 20px;\n    border: none;\n    border-radius: 50%;\n    background: #052E26;\n    position: absolute;\n    top: auto;\n    bottom: auto;\n    left: 0;\n}\n\n.progressButtonRight {\n    right: 0;\n    left: initial;\n}\n\n.progressButtonIcon {\n    width: 24px;\n    height: 24px;\n}\n\n.progressButtonIconRight {\n    transform: rotate(180deg);\n}\n\n.imgViewBigOnes {\n    height: 400px;\n    transition: 0.3s;\n}\n\n.imgViewPropertySample {\n    border: none;\n    border-radius: 10px;\n    width: auto;\n    aspect-ratio: auto;\n}\n\n.imgViewSmallOnesCon {\n    height: 150px;\n    overflow-x: auto;\n    padding-bottom: 15px;\n}\n\n.imgViewSmallOnesCon::-webkit-scrollbar {\n    /* opacity: 0; */\n    height: 8px !important;\n}\n\n.imgViewSmallOnes {\n    gap: 10px;\n}\n\n.imgViewMiniPropertySample {\n    border: 3px solid transparent;\n    border-radius: 5px;\n    overflow: hidden;\n    width: auto;\n    aspect-ratio: auto;\n}\n\n.imgViewMiniPropertySample.imgInView {\n    border-color: #052E26;\n}\n\n.imgViewClose {\n    top: 40px;\n    right: 40px;\n    width: 50px;\n    height: 50px;\n    bottom: initial;\n    padding: 0 !important;\n    left: initial;\n    background: #000;\n    color: #fff;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px; /* 128.571% */\n}\n\n.xCheckout {\n    border-radius: 15px;\n    border: 1px solid #e3e4e9;\n    background: #f6f6f6;\n    padding: 28px 58px 14.5px;\n    margin-top: 14px;\n}\n\n.xCheckoutTitle {\n    color: #000;\n    text-align: center;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 100% */\n}\n\n.xCheckoutLabel {\n    margin-top: 18px;\n    gap: 8px;\n}\n\n.xCheckoutLabelSpan {\n    color: #494747;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px; /* 128.571% */\n}\n\n.xCheckoutHiddenDiv {\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    background: var(--W-Background, #fff);\n    padding: 16px 20px;\n    gap: 30px;\n}\n\n.xCheckoutHiddenR {\n    color: #13141c;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px; /* 166.667% */\n    width: 32px;\n}\n\n.xCheckoutInput {\n    color: #666;\n    font-family: Manrope;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    border: none;\n    outline: none;\n    width: calc(100% - 62px);\n}\n\n.xInfoCon {\n    border-top: 1px solid #d4d4d4;\n    padding: 24px 0 31px;\n    margin-top: 30px;\n}\n\n.xInfo {\n    width: 33%;\n}\n\n.xInfoTitle {\n    color: var(--Grey-30, #999);\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 19.2px; /* 137.143% */\n}\n\n.xInfoSubtitle {\n    color: #13141c;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 22px; /* 122.222% */\n}\n\n.xCost {\n    padding: 23px 0;\n    border-top: 1px solid #d4d4d4;\n}\n\n.xCostTag {\n    color: #696969;\n    font-family: Manrope;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%; /* 21px */\n}\n\n.xCostValue {\n    color: #595959;\n    text-align: right;\n    font-family: Manrope;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%; /* 17.6px */\n}\n\n.xCheckoutNotice {\n    gap: 15px;\n    padding: 20px 0 78px;\n}\n\n.xCheckoutNoticeText {\n    color: #5f5f5f;\n    font-family: Manrope;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 140%; /* 16.8px */\n}\n\n.xCheckoutNoticeTextLink {\n    color: #5f5f5f;\n    font-family: Manrope;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 140%;\n}\n\n.purchaseButton {\n    color: #fff;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; /* 88.889% */\n    padding: 0 20px;\n    min-width: 280px;\n    height: 73px;\n    padding: 0px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 125px;\n    flex-shrink: 0;\n    border-radius: 15px;\n    background: #052E26;\n    margin: 0;\n}\n\n.xOffers {\n    gap: 108px;\n    padding-top: 41px;\n}\n\n.xOffer {\n    gap: 17px;\n}\n\n.xOfferIcon {\n    width: 25px;\n    height: 31.25px;\n}\n\n.xOfferDetails {\n}\n\n.xOfferTitle {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px; /* 163.636% */\n}\n\n.xOfferValue {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px; /* 100% */\n}\n\n.xxGrossYield {\n    margin-top: 15px;\n    border-top: 1px solid #e6e6e6;\n    border-bottom: 1px solid #e6e6e6;\n}\n\n.xxGrossYieldTag {\n    color: #828993;\n    font-family: Manrope;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 30px; /* 230.769% */\n}\n\n.xxGrossYieldValue {\n    color: #13141c;\n    text-align: right;\n    font-family: Manrope;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px; /* 230.769% */\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n    .navItems {\n        gap: 0 !important;\n    }\n\n    .pMDetailsCon {\n        padding-top: 5px;\n    }\n\n    .propertyDetail {\n        margin-top: 19px;\n    }\n\n    .pMPropertyFeaturesCon {\n        padding-bottom: 15px;\n    }\n\n    .pMPropertyFeatIcon {\n        width: 16px;\n        height: 16px;\n        flex-shrink: 0;\n    }\n\n    .pPMPropertyFeatTxt {\n        color: #828993;\n        font-family: Manrope;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 18px; /* 150% */\n    }\n\n    .pMPropertyInfoCon {\n        width: 100%;\n    }\n\n    .pMPropertyMetricsParent {\n        width: 100%;\n        gap: 20px;\n        margin-top: 31px;\n    }\n\n    .pMPropertyMetricsCon {\n        width: 100% !important;\n    }\n\n    .secondMetricCon {\n        width: 100% !important;\n        margin-top: 0;\n        padding: 24px 24px 30px;\n    }\n\n    .propDownloadBtn {\n        padding: 15px 13px 15px 15px;\n    }\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 850px) and (min-width: 821px) {\n    .pMPropertyInfoCon {\n        width: 100% !important;\n    }\n\n    .pMPropertyMetricsParent {\n        width: 100% !important;\n        gap: 20px !important;\n        margin-top: 31px !important;\n    }\n\n    .pMPropertyMetricsCon:not(.secondMetricCon) {\n        width: calc(60% - 20px);\n    }\n\n    .secondMetricCon {\n        width: 40%;\n        margin-top: 0 !important;\n        padding: 24px 24px 30px !important;\n    }\n\n    .propDownloadBtn {\n        padding: 15px 13px 15px 15px !important;\n    }\n\n    /* .investMetricsParent {\n        width: min(497px, calc(60% - 42px));\n    } */\n    .investMetricsDummy {\n        width: min(497px, calc(60%));\n    }\n\n    /* .iPadHidden{\n        display: none !important;\n    }\n\n    .propThemeTitle {\n        margin: 60px 0 65px !important;\n    }\n\n    .investMetricsParent {\n        position: static;\n        width: 100%;\n    } */\n}\n\n@media only screen and (max-width: 820px) {\n    .navBarCon {\n        padding: 30px 42px;\n    }\n\n    .propertiesBannerCon {\n        padding: 195px 42px 0;\n        /* background-size: 1440px 450px; */\n    }\n\n    .propertyTheme {\n        color: #fff;\n        font-family: Manrope;\n        font-size: 50px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 100%; /* 50px */\n    }\n\n    .propertiesFilterCon {\n        margin-top: 71px;\n    }\n\n    .filterCon {\n        width: calc(48%);\n    }\n\n    .searchCon_ {\n        display: flex !important;\n    }\n\n    .searchCon_ {\n        width: calc(48%) !important;\n    }\n\n    .searchCon {\n        display: none !important;\n        padding: 0 !important;\n    }\n\n    .searchButton {\n        display: flex;\n        width: 100% !important;\n        height: 56px !important;\n        padding: 0px 11px 0px 23px !important;\n        justify-content: center;\n        align-items: center;\n        gap: 21px !important;\n        flex-shrink: 0;\n        background: #052E26 !important;\n        color: #fff !important;\n        justify-content: center !important;\n    }\n\n    .searchButton svg g path {\n        color: #fff !important;\n        /* fill: #fff; */\n        stroke: #fff !important;\n    }\n\n    .gap {\n        display: flex !important;\n        height: 20px;\n    }\n\n    .propertiesListingCon {\n        padding: 43px 42px;\n    }\n\n    .pProperty {\n        width: 48% !important;\n        margin-bottom: 35px;\n    }\n\n    .pPropertyImage {\n        padding: 30px !important;\n    }\n\n    .pMPropertyMetricsCon:not(.noPadding) {\n        padding: 15px 30px !important;\n    }\n\n    .pPropertyName {\n        font-size: 18px !important;\n        font-style: normal !important;\n        font-weight: 600 !important;\n        line-height: 30px !important; /* 166.667% */\n    }\n\n    .propertyLocation {\n        font-size: 12px !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n        line-height: 18px !important; /* 150% */\n    }\n\n    .pPropLeft {\n        font-size: 13px !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n        line-height: 30px !important; /* 230.769% */\n    }\n\n    .pPropRight {\n        font-size: 13px !important;\n        font-style: normal !important;\n        font-weight: 600 !important;\n        line-height: 30px !important; /* 230.769% */\n    }\n\n    .pPropertyShares {\n        font-size: 12px !important;\n        font-style: normal !important;\n        font-weight: 700 !important;\n        line-height: 30px !important; /* 250% */\n        padding: 3px 15px !important;\n        border-radius: 10px !important;\n    }\n\n    .propertyBannerCon {\n        padding: 33px 42px 62px !important;\n    }\n\n    .container {\n        padding-left: 42px;\n        padding-right: 42px;\n    }\n\n    .pViewPicturesIcon {\n        width: 20px;\n        height: 20px;\n    }\n\n    .pMPropertyInfoCon {\n        width: 100%;\n    }\n\n    .pMPropertyMetricsParent {\n        width: 100%;\n        gap: 20px;\n        margin-top: 31px;\n    }\n\n    .pMPropertyMetricsCon:not(.secondMetricCon) {\n        width: calc(60% - 20px);\n    }\n\n    .secondMetricCon {\n        width: 40%;\n        margin-top: 0;\n        padding: 24px 24px 30px;\n    }\n\n    .propDownloadBtn {\n        padding: 15px 13px 15px 15px;\n    }\n\n    .propDTxt {\n    }\n\n    .dIcon {\n    }\n\n    /*.investMetricsParent {\n        width: min(497px, calc(60% - 42px));\n        right: 42px;\n    } */\n    .investMetricsDummy {\n        width: min(497px, calc(60%));\n    }\n\n    .propThemeTitle {\n        margin: 60px 0 65px !important;\n    }\n\n    /* .investMetricsParent {\n        position: static;\n        width: 100%;\n    } */\n    .imgViewParent {\n        padding: 40px 20px !important;\n    }\n\n    /*\n    .imgViewPropertySampleCon {\n        height: initial !important;\n    }\n\n    .imgViewPropertySample {\n        height: auto !important;\n        width: 100% !important;\n    } */\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n    .parent {\n        padding-top: 85px;\n    }\n\n    .navBarCon {\n        padding: 20px 30px;\n    }\n\n    .propertiesBannerCon {\n        padding: 141px 30px 0;\n    }\n\n    .propertiesFilterCon {\n        padding: 38px 31px;\n        margin-top: 126px;\n    }\n\n    .propertiesFilterInnerCon {\n        flex-direction: column !important;\n        justify-content: center !important;\n        align-items: center !important;\n        gap: 24px !important;\n    }\n\n    .filterCon {\n        width: calc(100%);\n    }\n\n    .searchCon_ {\n        width: calc(100%) !important;\n    }\n\n    .gap {\n        display: none !important;\n    }\n\n    .firstPropMetric {\n        width: initial !important;\n        margin-right: auto !important;\n    }\n\n    .firstPropMetric + div {\n        width: initial !important;\n        flex: none !important;\n        margin-left: auto !important;\n    }\n\n    .propertiesListingCon {\n        padding: 41px 29px;\n    }\n\n    .pProperty {\n        width: 100% !important;\n        margin-bottom: 27px;\n    }\n\n    .pPropertyImage {\n        height: 254px !important;\n        padding: 30px !important;\n    }\n\n    .pPropLeft {\n        font-size: 13px !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n        line-height: 30px !important; /* 230.769% */\n    }\n\n    .pPropRight {\n        font-size: 13px !important;\n        font-style: normal !important;\n        font-weight: 600 !important;\n        line-height: 30px !important; /* 230.769% */\n    }\n\n    .pPropertyShares {\n        font-size: 12px !important;\n        font-style: normal !important;\n        font-weight: 700 !important;\n        line-height: 30px !important; /* 250% */\n        padding: 3px 15px !important;\n        border-radius: 10px !important;\n    }\n\n    .propertyBannerCon {\n        padding: 20px 30px 28px !important;\n    }\n\n    .container {\n        padding-left: 30px;\n        padding-right: 30px;\n    }\n\n    .pPLocationInfoCon {\n        padding: 0 16px;\n    }\n\n    .pPLocationInfoCon_ {\n        padding: 0;\n    }\n\n    .pPLocation {\n        color: #fff;\n        font-family: Manrope;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 18px; /* 128.571% */\n    }\n\n    .pMDetailsCon {\n        padding-top: 5px;\n    }\n\n    .propertyDetail {\n        margin-top: 19px;\n    }\n\n    .pMPropertyFeaturesCon {\n        padding-bottom: 15px;\n    }\n\n    .pMDetailsCon {\n        padding-bottom: 169.5px;\n    }\n\n    .pMPropertyFeatIcon {\n        width: 16px;\n        height: 16px;\n        flex-shrink: 0;\n    }\n\n    .pPMPropertyFeatTxt {\n        color: #828993;\n        font-family: Manrope;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 18px; /* 150% */\n    }\n\n    .pMPropertyInfoCon {\n        width: 100%;\n    }\n\n    .pMPropertyMetricsParent {\n        width: 100%;\n        gap: 20px;\n        margin-top: 31px;\n    }\n\n    .propDocTitle {\n        color: #13141c;\n        font-family: Manrope;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 14.4px */\n    }\n\n    .pMPropertyMetricsCon {\n        width: 100% !important;\n        border: none;\n        border-radius: 0px !important;\n        padding: 0;\n    }\n\n    .propertyListing_ {\n        border-top: 1px solid #e3e4e9 !important;\n        padding-top: 19px !important;\n    }\n\n    .m19 {\n        margin-bottom: 19px !important;\n    }\n\n    .pPropertyDetails {\n        /* padding: 10px 0 !important; */\n    }\n\n    .secondMetricCon {\n        width: 100% !important;\n        margin-top: 32px !important;\n        border: none !important;\n        padding: 10px 0 !important;\n    }\n\n    .propDownloadBtn {\n        padding: 15px 13px 15px 15px;\n    }\n\n    .searchButton {\n        background: #052E26 !important;\n        color: #fff !important;\n    }\n\n    .searchButton path {\n        color: #fff !important;\n        /* fill: #fff; */\n        stroke: #fff !important;\n    }\n\n    .propertyBanner_ {\n        width: 100%;\n        height: initial !important;\n        justify-content: flex-start !important;\n        align-items: center !important;\n    }\n\n    .youAreInvestingIn {\n        color: #fff;\n        font-family: Manrope;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 18px; /* 128.571% */\n        margin-bottom: 14px;\n    }\n\n    .propThemeTitle {\n        margin: 46px 0 45px !important;\n    }\n\n    .propertyTheme {\n        color: #fff;\n        font-family: Manrope;\n        font-size: 50px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 90%; /* 45px */\n        text-transform: capitalize;\n    }\n\n    .investMetricsParent {\n        position: static;\n        width: 100%;\n    }\n\n    .investMetricsParent_ {\n        padding: 34px 30px 41px;\n    }\n\n    .popup {\n        padding: 115px 26px 27px;\n        margin-bottom: 50px;\n    }\n\n    .popupCheckCon {\n        width: 70px;\n        height: 70px;\n    }\n\n    .popupCheck {\n        width: 31px;\n        height: 31px;\n    }\n\n    .popupSuccessTitle {\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 21.6px */\n    }\n\n    .popupSuccessMessage {\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 18px; /* 150% */\n    }\n\n    .progressButton {\n        position: relative !important;\n        width: calc(50% - 5px) !important;\n        border-radius: 10px !important;\n        margin: 0 auto;\n    }\n\n    .imgViewParent {\n        padding: 20px 10px 100px !important;\n    }\n\n    .imgViewBigOnes {\n        height: 250px;\n    }\n\n    .imgViewPropertySampleCon {\n        height: initial !important;\n    }\n\n    .imgViewPropertySample {\n        height: auto !important;\n        width: 100% !important;\n    }\n\n    .imgViewSmallOnesCon {\n        height: 100px !important;\n    }\n\n    .imgViewClose {\n        width: 100% !important;\n        padding: 20px 0 !important;\n        height: initial !important;\n        top: initial !important;\n        right: initial !important;\n        bottom: initial !important;\n        left: initial !important;\n        margin-top: 50px !important;\n    }\n\n    .xCheckout {\n        padding: 21px 27px 18px;\n        margin-top: 20px;\n    }\n\n    .xCheckoutTitle {\n        color: #000;\n        text-align: center;\n        font-family: Manrope;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 18px; /* 112.5% */\n    }\n\n    .xCheckoutLabel {\n        margin-top: 32px;\n    }\n\n    .xCheckoutHiddenDiv {\n        gap: 20px;\n    }\n\n    .xCheckoutHiddenR {\n        width: 20px;\n    }\n\n    .xCheckoutInput {\n        width: calc(100% - 40px);\n    }\n\n    .xInfoCon {\n        padding: 22px 0 13px;\n    }\n\n    .xInfo {\n        flex-direction: row !important;\n        width: initial;\n    }\n\n    .xInfo:not(.xInfo.xInfoWithBorder) {\n        flex: 1;\n    }\n\n    .xInfo.xInfoWithBorder {\n        padding-top: 10px;\n        margin-top: 16px;\n        border-top: 1px solid #d4d4d4;\n    }\n\n    .xInfoTitle {\n        font-size: 12px;\n    }\n\n    .xInfoSubtitle {\n        font-size: 15px;\n    }\n\n    .xCostTag {\n        font-size: 12px;\n    }\n\n    .xCostValue {\n        font-size: 14px;\n    }\n\n    .xCheckoutAgreement {\n        width: 100%;\n    }\n\n    .purchaseButton {\n        font-size: 14px;\n        width: 100%;\n        margin-top: 27px;\n    }\n\n    .xOffers {\n        gap: initial !important;\n        padding-top: 15px !important;\n    }\n\n    .xOffer {\n        width: 100%;\n    }\n\n    .xOffer:not(.xOffer:last-of-type) {\n        margin-bottom: 26px;\n    }\n\n    .xOfferIcon {\n        width: 20px;\n        height: 25.217px;\n    }\n\n    .xOfferTitle {\n        font-size: 9px;\n    }\n\n    .xOfferValue {\n        font-size: 14px;\n    }\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parent": `Properties_parent__L4U1X`,
	"innerMain": `Properties_innerMain__yZW8M`,
	"navBarCon": `Properties_navBarCon__n8U0W`,
	"navBar": `Properties_navBar__-pSsE`,
	"firstSection": `Properties_firstSection__jI+Ym`,
	"logoContainer": `Properties_logoContainer__EruVU`,
	"navItems": `Properties_navItems__vLaVE`,
	"navItem": `Properties_navItem__oKpUB`,
	"focused": `Properties_focused__JwMuV`,
	"propertiesBannerCon": `Properties_propertiesBannerCon__ch+JL`,
	"pPropertiesBannerCon": `Properties_pPropertiesBannerCon__4NHbw`,
	"propertyTheme": `Properties_propertyTheme__8HG5C`,
	"propertiesFilterCon": `Properties_propertiesFilterCon__rymi6`,
	"filterCon": `Properties_filterCon__tq8v0`,
	"searchCon": `Properties_searchCon__KjNKC`,
	"searchCon_": `Properties_searchCon___9GnqS`,
	"innerPropertiesFilterCon": `Properties_innerPropertiesFilterCon__wA5Uy`,
	"searchButton": `Properties_searchButton__u+9VA`,
	"searchTxt": `Properties_searchTxt__b-mGk`,
	"gap": `Properties_gap__6KsU+`,
	"propertiesListingCon": `Properties_propertiesListingCon__2yVSU`,
	"pProperty": `Properties_pProperty__im809`,
	"propertyLocCon": `Properties_propertyLocCon__6jNm5`,
	"propertyPin": `Properties_propertyPin__WHDlH`,
	"propertyLocation": `Properties_propertyLocation__bFkj5`,
	"propertyListing": `Properties_propertyListing__tQ8aY`,
	"propertyDetails": `Properties_propertyDetails__hbAuU`,
	"propDetailIcon": `Properties_propDetailIcon__9kTkH`,
	"propDetailText": `Properties_propDetailText__NlYwg`,
	"loadMoreCon": `Properties_loadMoreCon__Byl9p`,
	"loadMore": `Properties_loadMore__0XK9h`,
	"loadMoreTxt": `Properties_loadMoreTxt__MUWG2`,
	"loadMoreIcon": `Properties_loadMoreIcon__cj+c8`,
	"loading": `Properties_loading__KI1-4`,
	"propertyBannerCon": `Properties_propertyBannerCon__Q7QNr`,
	"container": `Properties_container__U39fz`,
	"propertyBanner": `Properties_propertyBanner__qxfUV`,
	"pPGoBackBtn": `Properties_pPGoBackBtn__4CjLm`,
	"pPGoBackIcon": `Properties_pPGoBackIcon__QSiF0`,
	"pPGoBackTxt": `Properties_pPGoBackTxt__1LRL+`,
	"pPLocationInfoCon": `Properties_pPLocationInfoCon__cryj8`,
	"pPLocationInfoCon_": `Properties_pPLocationInfoCon___OSi-3`,
	"modalParent": `Properties_modalParent__RnzTY`,
	"pPLocationCon": `Properties_pPLocationCon__xztXd`,
	"pPLocationIcon": `Properties_pPLocationIcon__xAHTW`,
	"pPLocation": `Properties_pPLocation__D+iGC`,
	"pViewPicturesBtn": `Properties_pViewPicturesBtn__5Lj3P`,
	"pViewPicturesBtnMini": `Properties_pViewPicturesBtnMini__oiIDc`,
	"pViewPicturesTxt": `Properties_pViewPicturesTxt__YHUDo`,
	"pViewPicturesIcon": `Properties_pViewPicturesIcon__9xo8T`,
	"pMDetailsCon": `Properties_pMDetailsCon__EV8S5`,
	"pMPropertyInfoCon": `Properties_pMPropertyInfoCon__wAXmX`,
	"pMPropertyFeaturesCon": `Properties_pMPropertyFeaturesCon__6j3hH`,
	"pMPropertyFeatIcon": `Properties_pMPropertyFeatIcon__5Uv08`,
	"pPMPropertyFeatTxt": `Properties_pPMPropertyFeatTxt__i75go`,
	"pMPropertyInformationCon": `Properties_pMPropertyInformationCon__QvaUw`,
	"pMPropInfoTitle": `Properties_pMPropInfoTitle__Xfob1`,
	"pMPropInfoContent": `Properties_pMPropInfoContent__35kvN`,
	"pMPropertyMetricsParent": `Properties_pMPropertyMetricsParent__y0IQ6`,
	"pMPropertyMetricsCon": `Properties_pMPropertyMetricsCon__6ld54`,
	"pPropMetricConBottom": `Properties_pPropMetricConBottom__RHWHD`,
	"propMetricTag": `Properties_propMetricTag__JJbDF`,
	"propMetricVal": `Properties_propMetricVal__lYgix`,
	"iViewDetailsBtn": `Properties_iViewDetailsBtn__-1JG8`,
	"sPlus": `Properties_sPlus__k4zyi`,
	"firstPropMetric": `Properties_firstPropMetric__ufBRE`,
	"propertyListing_": `Properties_propertyListing___8xv80`,
	"secondMetricCon": `Properties_secondMetricCon__iIvnR`,
	"propDocTitle": `Properties_propDocTitle__VnzsP`,
	"propDownloadBtn": `Properties_propDownloadBtn__2QHRM`,
	"propDTxt": `Properties_propDTxt__K4ycJ`,
	"dIcon": `Properties_dIcon__QADLZ`,
	"showMore": `Properties_showMore__MRgGV`,
	"showLess": `Properties_showLess__CRLxD`,
	"pMInvestNowCon_": `Properties_pMInvestNowCon___2wr0M`,
	"propertyBanner_": `Properties_propertyBanner___6WPFm`,
	"investMetricsParent": `Properties_investMetricsParent__NPpjE`,
	"investMetricsParent___": `Properties_investMetricsParent_____3Ti9A`,
	"investMetricsDummy": `Properties_investMetricsDummy__yb70C`,
	"pR20px": `Properties_pR20px__pgtY6`,
	"investPurBtn": `Properties_investPurBtn__iKcWt`,
	"investPriceInput": `Properties_investPriceInput__UScjJ`,
	"investPriceInputIcon": `Properties_investPriceInputIcon__abP9p`,
	"priceInput": `Properties_priceInput__SKcpk`,
	"pPropMetricCon_": `Properties_pPropMetricCon___m6HMR`,
	"paddedBottom": `Properties_paddedBottom__EJFry`,
	"lineH30": `Properties_lineH30__vabVS`,
	"pSharesInvest": `Properties_pSharesInvest__IkX4Z`,
	"popup": `Properties_popup__wUUYS`,
	"viewPortCon": `Properties_viewPortCon__ePPsB`,
	"viewPortButton": `Properties_viewPortButton__alA0s`,
	"popupSuccessTitle": `Properties_popupSuccessTitle__mCBMv`,
	"popupSuccessMessage": `Properties_popupSuccessMessage__GwIgm`,
	"youAreInvestingIn": `Properties_youAreInvestingIn__xjnxN`,
	"pP22px": `Properties_pP22px__5oDpI`,
	"imgViewParent": `Properties_imgViewParent__znVkD`,
	"imgViewBigCarousalCon": `Properties_imgViewBigCarousalCon__MCKRs`,
	"imgViewBigCarousal": `Properties_imgViewBigCarousal__f8hhB`,
	"progressButton": `Properties_progressButton__1HAOK`,
	"progressButtonRight": `Properties_progressButtonRight__K5FJH`,
	"progressButtonIcon": `Properties_progressButtonIcon__P5P8x`,
	"progressButtonIconRight": `Properties_progressButtonIconRight__U+xcm`,
	"imgViewBigOnes": `Properties_imgViewBigOnes__+s27p`,
	"imgViewPropertySample": `Properties_imgViewPropertySample__VryDY`,
	"imgViewSmallOnesCon": `Properties_imgViewSmallOnesCon__gtCb1`,
	"imgViewSmallOnes": `Properties_imgViewSmallOnes__FdNcV`,
	"imgViewMiniPropertySample": `Properties_imgViewMiniPropertySample__BHxzY`,
	"imgInView": `Properties_imgInView__WKRxE`,
	"imgViewClose": `Properties_imgViewClose__QmYQ-`,
	"xCheckout": `Properties_xCheckout__Jh5pt`,
	"xCheckoutTitle": `Properties_xCheckoutTitle__wnYo0`,
	"xCheckoutLabel": `Properties_xCheckoutLabel__SVH24`,
	"xCheckoutLabelSpan": `Properties_xCheckoutLabelSpan__07uxr`,
	"xCheckoutHiddenDiv": `Properties_xCheckoutHiddenDiv__TB-BC`,
	"xCheckoutHiddenR": `Properties_xCheckoutHiddenR__Oan9e`,
	"xCheckoutInput": `Properties_xCheckoutInput__Cgw9C`,
	"xInfoCon": `Properties_xInfoCon__TW7Oo`,
	"xInfo": `Properties_xInfo__qYkHR`,
	"xInfoTitle": `Properties_xInfoTitle__W1zev`,
	"xInfoSubtitle": `Properties_xInfoSubtitle__T0Pt6`,
	"xCost": `Properties_xCost__JWHrI`,
	"xCostTag": `Properties_xCostTag__ZUluH`,
	"xCostValue": `Properties_xCostValue__++4hf`,
	"xCheckoutNotice": `Properties_xCheckoutNotice__femWo`,
	"xCheckoutNoticeText": `Properties_xCheckoutNoticeText__vxA9y`,
	"xCheckoutNoticeTextLink": `Properties_xCheckoutNoticeTextLink__+kqC2`,
	"purchaseButton": `Properties_purchaseButton__BsdHL`,
	"xOffers": `Properties_xOffers__G2vFg`,
	"xOffer": `Properties_xOffer__X0RWe`,
	"xOfferIcon": `Properties_xOfferIcon__pK2Gf`,
	"xOfferDetails": `Properties_xOfferDetails__Ppd5B`,
	"xOfferTitle": `Properties_xOfferTitle__o0lJg`,
	"xOfferValue": `Properties_xOfferValue__-kVuc`,
	"xxGrossYield": `Properties_xxGrossYield__GnzuD`,
	"xxGrossYieldTag": `Properties_xxGrossYieldTag__d4Oda`,
	"xxGrossYieldValue": `Properties_xxGrossYieldValue__15KdQ`,
	"propertyDetail": `Properties_propertyDetail__1LoDo`,
	"pPropertyImage": `Properties_pPropertyImage__3G3GP`,
	"noPadding": `Properties_noPadding__9ETfl`,
	"pPropertyName": `Properties_pPropertyName__Cbpwx`,
	"pPropLeft": `Properties_pPropLeft__Sf2po`,
	"pPropRight": `Properties_pPropRight__LbnTO`,
	"pPropertyShares": `Properties_pPropertyShares__JpU-J`,
	"propThemeTitle": `Properties_propThemeTitle__jKw9x`,
	"propertiesFilterInnerCon": `Properties_propertiesFilterInnerCon__r-Tlp`,
	"m19": `Properties_m19__1duoH`,
	"pPropertyDetails": `Properties_pPropertyDetails__Kdn09`,
	"investMetricsParent_": `Properties_investMetricsParent___QkeEI`,
	"popupCheckCon": `Properties_popupCheckCon__X3ZLd`,
	"popupCheck": `Properties_popupCheck__-B+uL`,
	"imgViewPropertySampleCon": `Properties_imgViewPropertySampleCon__Nhf7P`,
	"xInfoWithBorder": `Properties_xInfoWithBorder__21T9O`,
	"xCheckoutAgreement": `Properties_xCheckoutAgreement__o4LdV`
};
export default ___CSS_LOADER_EXPORT___;
